import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartImageSettings, IPartImageSettingsResponse } from "../models/PartImageSettings";
import { DefaultResponse } from "../models/system";

export default function usePartImageSettings() {
  const { get, post, postGetFile } = useApiHelper();
  const queryClient = useQueryClient();

  const settings = useQuery({
    queryKey: ["partImageSettings"],
    queryFn: () => get<IPartImageSettingsResponse>("/partimagesettings"),
  });

  const createOrUpdate = useMutation(
    (settings: IPartImageSettings) => post<IPartImageSettingsResponse>("/partimagesettings", settings as any),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["partImageSettings"]);
      },
    }
  );

  const apply = useMutation(
    (partIds: string[]) => post<DefaultResponse>("/partimagesettings/apply", partIds as any),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["partImageSettings"]);
        // Optionally invalidate parts queries if needed
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["part"]);
      },
    }
  );

  const getPreview = async (settings: IPartImageSettings): Promise<string> => {
    const blob = await postGetFile<IPartImageSettings>("/partimagesettings/preview", settings as any);
    return URL.createObjectURL(blob);
  };

  return {
    settings: settings.data?.data,
    loading: settings.isLoading,
    createOrUpdate,
    apply,
    getPreview,
  };
}
